/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Battery Low Icon component.
 */
export const BatteryLowIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19783)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M12.834 4C13.1101 4 13.334 4.22386 13.334 4.5L13.334 11.5C13.334 11.7761 13.1101 12 12.834 12L0.499982 12C0.22384 12 -1.65524e-05 11.7761 -1.65403e-05 11.5L-1.62343e-05 4.5C-1.62222e-05 4.22386 0.223842 4 0.499984 4L12.834 4ZM11.9989 5.1333L11.9989 5.3335L11.9989 5.5333L11.9989 10.4666L11.9989 10.6668L11.9989 10.8666L1.13172 10.8666L1.13172 5.1333L11.9989 5.1333ZM3.38525 10.4666L3.38525 5.5333L1.53174 5.5333L1.53174 10.4666L3.38525 10.4666Z' fill={iconColor} />
        <rect x='16' y='5.33398' width='5.33333' height='1.3334' transform='rotate(90 16 5.33398)' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19783'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BatteryLowIcon;
